import { valueExists } from "src/app/methods/valueExists";

export const isObjectEmpty = (obj = {}) => {
  if (!valueExists(obj)) return true;
  return Object.keys(obj).length === 0;
};
